import SymbolsFactory from "@/factories/SymbolsFactory";
import Facade from "@/Facade";
import ReelsConfig from "@/config/ReelsConfig";
import Config from "@/config/Config";


export default class DataField {

    constructor() {
        Facade.dataField = this
        this.init()
    }

    init() {

        this.container = new PIXI.Container()
        this.symbolFactory = new SymbolsFactory(this.container)
        this.allSymbols = []
        this.poolOut = this.symbolFactory.poolOut
        this.poolIn = this.symbolFactory.poolIn
    }

    initSymbols(initData, multipliers) {
        this.allSymbols = this.createSymbols(initData, multipliers)
    }

    createSymbols(initData, multipliers) {
        const allSymbols = []
        let yy = 0
        let xx = 0

        for (let i = 0; i < ReelsConfig.TOTAL_REELS; i++) {
            allSymbols.push([])
            yy = 0
            xx = Config.pattern.reels.reels[i].x

            for (let j = 0; j < ReelsConfig.TOTAL_SYMBOLS_PER_REEL[i]; j++) {
                let symbol = this.symbolFactory.poolOut(initData[i][j].id, multipliers[i][j])
                symbol.x = xx
                symbol.y = yy
                yy += ReelsConfig.SYMBOL_HEIGHT[i]
                allSymbols[i].unshift(symbol)
                this.container.addChild(symbol)
            }
        }

        return allSymbols
    }

    createSymbols2() {
        const allSymbols = []
        for (let i = 0; i < ReelsConfig.TOTAL_REELS; i++) {
            allSymbols.push([])
            for (let j = 0; j < ReelsConfig.TOTAL_SYMBOLS_PER_REEL[i] + 5; j++) {
                let symbol = this.symbolFactory.poolOut(4001)
                allSymbols[i].push(symbol)
                this.container.addChild(symbol)
            }
        }
        return allSymbols
    }

    updateSymbols(initData, multipliers) {

        this.allSymbols.forEach( (column, i) => {
                let yy = -( ReelsConfig.SYMBOL_HEIGHT[i] + ReelsConfig.SYMBOL_GAP ) * ( ReelsConfig.TOTAL_SYMBOLS_PER_REEL[i] - ReelsConfig.VISIBLED_SYMBOLS[i] ) / 2
                let xx = Config.pattern.reels.reels[i].x
                column.forEach((symbol, j) => {
                    symbol.changeTextureByIndex(initData[i][j])
                    symbol.x = xx
                    symbol.y = yy
                    yy += ReelsConfig.SYMBOL_HEIGHT[i] + ReelsConfig.SYMBOL_GAP

                })
            }
        )
    }


    get symbols() {
        return this.allSymbols
    }


}